export function loadScript(src) {
  return new Promise((resolve, reject) => {
    const js = document.createElement('script');
    js.src = src;
    js.onload = () => resolve();
    js.onerror = () => reject(new Error(`Failed to load script ${src}`));
    document.head.appendChild(js);
  });
}

let documentBodyStyle = null;
export function getCssVar(varName) {
  try {
    documentBodyStyle = documentBodyStyle || window.getComputedStyle(document.body);

    return documentBodyStyle.getPropertyValue(`--${varName}`);
  } catch (err) {
    return null;
  }
}
